module.exports = __webpack_public_path__ + "media/typy/rolnicze-29fbea26.png";